module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    staticClass: "Office"
  }, [_c('md-whiteframe', {
    staticClass: "shadow shadow-faint"
  }, [_c('div', {
    staticClass: "search search--field"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('md-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.query),
      expression: "search.query"
    }],
    staticStyle: {
      "outline": "0"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.translate.pages.office.index.search,
      "data-step": "4",
      "data-intro": "Escribe el nombre de la Consulta, se realizara automaticamente"
    },
    domProps: {
      "value": (_vm.search.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.searchIndicator))])]), _vm._v(" "), (_vm.addButton) ? _c('md-button', {
    staticClass: "md-icon-button md-raised button",
    attrs: {
      "data-step": "1",
      "data-intro": "Presiona el Boton de Añadir Consulta"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addOffice($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1) : _c('md-button', {
    staticClass: "md-icon-button md-raised button-remove",
    nativeOn: {
      "click": function($event) {
        _vm.removeOffices($event)
      }
    }
  }, [_c('md-icon', [_vm._v("clear")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table table--office table-mobile has-status table--queries"
  }, [(_vm.offices.length > 0) ? _c('md-table-card', {
    staticClass: "table--wrap"
  }, [(_vm.disabledRegion) ? _c('div', [_c('div', {
    staticClass: "sk-rotating-plane"
  })]) : _c('div', [_c('md-table', {
    attrs: {
      "md-sort": "name",
      "md-sort-by": "name"
    },
    on: {
      "sort": _vm.onSort,
      "select": _vm.onSelect
    }
  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
    staticClass: "td-sort-name center-mobile",
    attrs: {
      "md-sort-by": "name"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.fields.name))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile",
    attrs: {
      "md-sort-by": "street"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.fields.address))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "hidden-mobile"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.fields.schedule))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "text-center hidden-mobile",
    attrs: {
      "md-sort-by": "active"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.fields.status))]), _vm._v(" "), _c('md-table-head', {
    staticClass: "text-center hidden-mobile"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.fields.actions))])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.offices), function(row, rowIndex) {
    return _c('md-table-row', {
      key: rowIndex,
      attrs: {
        "md-item": row,
        "md-selection": ""
      }
    }, [_c('md-table-cell', {
      staticClass: "name--cell"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('span', {
      staticClass: "mini_cover_image",
      style: ('background-image: url(' + _vm.srcImage(row.path) + ');')
    })]), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('span', {
      staticClass: "subname visible-mobile"
    }, [_vm._v(_vm._s(row.street) + " " + _vm._s(row.number) + ", " + _vm._s(row.comunity))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "hidden-mobile"
    }, [_c('span', {
      staticClass: "hidden-mobile"
    }, [_vm._v(_vm._s(row.street) + " " + _vm._s(row.number) + ", " + _vm._s(row.comunity))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "hidden-small"
    }, [(row.schedules.length == 0) ? _c('span', [_vm._v(_vm._s(_vm.translate.pages.office.index.hour_no_define))]) : _c('span', [_vm._v(_vm._s(_vm._f("formatDays")(row.schedules[0].turns_active)))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "static-mobile"
    }, [_c('div', {
      staticClass: "enabled",
      class: {
        'active': row.active
      }
    }, [_vm._v(_vm._s(_vm._f("formatEnabled")(row.active)))])]), _vm._v(" "), _c('md-table-cell', {
      staticClass: "actions"
    }, [_c('md-icon', {
      staticClass: "icon-edit raised",
      nativeOn: {
        "click": function($event) {
          _vm.openDialog('tasks', row, rowIndex)
        }
      }
    }, [_vm._v("attach_money")]), _vm._v(" "), _c('md-icon', {
      staticClass: "icon-edit raised",
      attrs: {
        "data-step": rowIndex === 0 ? 2 : '',
        "data-intro": "Presiona el Boton de Editar"
      },
      nativeOn: {
        "click": function($event) {
          _vm.openDialog('edit', row, rowIndex)
        }
      }
    }, [_vm._v("edit")]), _vm._v(" "), _c('md-icon', {
      staticClass: "icon-delete raised",
      attrs: {
        "data-step": rowIndex === 0 ? 3 : '',
        "data-intro": "Presiona el Boton de Eliminar"
      },
      nativeOn: {
        "click": function($event) {
          _vm.remove(row, rowIndex)
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  }))], 1), _vm._v(" "), _c('md-dialog', {
    ref: "edit",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": _vm.close,
      "md-esc-to-close": _vm.close
    }
  }, [_c('md-dialog-content', [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    staticClass: "modal-wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "30"
    }
  }, [_c('div', {
    staticClass: "picture"
  }, [_c('img', {
    staticStyle: {
      "max-height": "160px"
    },
    attrs: {
      "src": _vm.path
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon camera_upload",
    on: {
      "click": _vm.uploadAvatarIcon
    }
  }, [_c('md-icon', [_vm._v("photo_camera")])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    staticStyle: {
      "width": "100%",
      "display": "block",
      "text-align": "center",
      "margin-top": "20px",
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.hasOwnProperty('formAvatar') && _vm.errors.formAvatar.length > 3 ? _vm.errors.formAvatar : ''))]), _vm._v(" "), _c('form', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "formAvatar",
      "method": "POST",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    attrs: {
      "id": "fileAvatar",
      "type": "file",
      "name": "avatar"
    },
    on: {
      "change": _vm.onAvatarChange
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  })])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "70"
    }
  }, [_c('div', {
    staticClass: "multiple checkbox-list",
    class: {
      'error': _vm.errors.speciality.invalid
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.specialities))]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, _vm._l((_vm.specialities), function(speciality) {
    return _c('md-checkbox', {
      key: speciality.id,
      staticClass: "option",
      on: {
        "change": function($event) {
          _vm.onChosen($event, speciality.id)
        }
      },
      model: {
        value: (speciality.checked),
        callback: function($$v) {
          speciality.checked = $$v
        },
        expression: "speciality.checked"
      }
    }, [_vm._v(_vm._s(speciality.name))])
  })), _vm._v(" "), (_vm.errors.speciality.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.speciality.msg))]) : _vm._e()])]), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.name.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.name))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.currentOffice.name),
      callback: function($$v) {
        _vm.currentOffice.name = $$v
      },
      expression: "currentOffice.name"
    }
  }), _vm._v(" "), (_vm.errors.name.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.name.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container h10",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.duration.invalid
    }
  }, [_c('md-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.duration))]), _vm._v(" "), _c('md-input', {
    staticClass: "forcedisabled",
    attrs: {
      "disabled": "",
      "type": "number"
    },
    model: {
      value: (_vm.currentOffice.duration),
      callback: function($$v) {
        _vm.currentOffice.duration = $$v
      },
      expression: "currentOffice.duration"
    }
  }), _vm._v(" "), (_vm.errors.duration.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.duration.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container",
    staticStyle: {
      "margin-bottom": "27px !important"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('vue-select', {
    staticClass: "md-input select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.regions,
      "placeholder": "Provincia",
      "on-change": _vm.changeRegion
    },
    model: {
      value: (_vm.currentOffice.region.label),
      callback: function($$v) {
        _vm.currentOffice.region.label = $$v
      },
      expression: "currentOffice.region.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), (_vm.errors.region_id.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.region_id.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container md-input-container",
    staticStyle: {
      "margin-bottom": "27px !important"
    },
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('vue-select', {
    staticClass: "md-input select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.comunities,
      "placeholder": "Comuna",
      "on-change": _vm.changeCity
    },
    model: {
      value: (_vm.currentOffice.city.label),
      callback: function($$v) {
        _vm.currentOffice.city.label = $$v
      },
      expression: "currentOffice.city.label"
    }
  }, [_c('span', {
    slot: "no-options"
  }, [_vm._v("No se encontraron resultados.")])]), _vm._v(" "), (_vm.errors.comunity.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.comunity.msg))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.street.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.street))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.currentOffice.street),
      callback: function($$v) {
        _vm.currentOffice.street = $$v
      },
      expression: "currentOffice.street"
    }
  }), _vm._v(" "), (_vm.errors.street.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.street.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.number.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.number))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.currentOffice.number),
      callback: function($$v) {
        _vm.currentOffice.number = $$v
      },
      expression: "currentOffice.number"
    }
  }), _vm._v(" "), (_vm.errors.number.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.number.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.phone.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.phone))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.currentOffice.phone),
      callback: function($$v) {
        _vm.currentOffice.phone = $$v
      },
      expression: "currentOffice.phone"
    }
  }), _vm._v(" "), (_vm.errors.phone.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.phone.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hour_confirm.invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.hour_confirm))]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.currentOffice.hour_confirm),
      callback: function($$v) {
        _vm.currentOffice.hour_confirm = $$v
      },
      expression: "currentOffice.hour_confirm"
    }
  }), _vm._v(" "), (_vm.errors.hour_confirm.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.hour_confirm.msg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "container",
    attrs: {
      "md-flex-small": "100",
      "md-flex": "50"
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.active.invalid
    }
  }, [_c('label', {
    attrs: {
      "for": "active"
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.status))]), _vm._v(" "), _c('md-select', {
    attrs: {
      "id": "active"
    },
    model: {
      value: (_vm.currentOffice.active),
      callback: function($$v) {
        _vm.currentOffice.active = $$v
      },
      expression: "currentOffice.active"
    }
  }, [_c('md-option', {
    key: 1,
    attrs: {
      "value": 1
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.status_option.able))]), _vm._v(" "), _c('md-option', {
    key: 0,
    attrs: {
      "value": 0
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.fields.status_option.disable))])], 1), _vm._v(" "), (_vm.errors.active.invalid) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.active.msg))]) : _vm._e()], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "modal--footer"
  }, [_c('md-button', {
    staticClass: "float-l md-primary sm-size md-size btn--cancel",
    staticStyle: {
      "padding": "0 15px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('edit')
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.cancel))]), _vm._v(" "), _c('md-button', {
    staticClass: "float-r md-primary sm-size md-size btn--blue",
    staticStyle: {
      "padding": "0 15px"
    },
    attrs: {
      "disabled": _vm.process
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('edit', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.save))])], 1)], 1)], 1)]) : _c('div', [(_vm.search.isQuery) ? _c('h3', {
    staticClass: "not-found mini-found"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.no_name_result) + " \""), _c('strong', [_vm._v(_vm._s(_vm.search.query) + "\".")])]) : _c('h3', [(_vm.fetchData) ? _c('span', {
    staticClass: "not-found mini-found"
  }, [_vm._v(_vm._s(_vm.translate.pages.office.index.no_records))]) : _c('span', [_c('div', {
    staticClass: "sk-rotating-plane"
  })])])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "display": "block",
      "width": "100%"
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: " md-raised button",
    staticStyle: {
      "background": "#96c972",
      "color": "white",
      "position": "fixed",
      "bottom": "10px",
      "right": "10px",
      "z-index": "10000"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openHelper($event)
      }
    }
  }, [_vm._v("\n        Tutor Interactivo "), _c('md-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('md-dialog', {
    ref: "helper",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": _vm.close,
      "md-esc-to-close": _vm.close
    }
  }, [_c('md-dialog-content', [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v("Tutor Interactivo")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    staticClass: "modal-wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_vm._v("\n                Seleccione un proceso:"), _c('br'), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "width": "100%"
    },
    nativeOn: {
      "click": function($event) {
        _vm.launchTutor(1)
      }
    }
  }, [_vm._v("Crear Una Consulta")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.offices.length == 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.launchTutor(2)
      }
    }
  }, [_vm._v("Editar Una Consulta")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.offices.length == 0
    },
    nativeOn: {
      "click": function($event) {
        _vm.launchTutor(3)
      }
    }
  }, [_vm._v("Eliminar Una Consulta")])], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "modal--footer"
  }, [_c('md-button', {
    staticClass: "float-l md-primary sm-size md-size btn--cancel",
    staticStyle: {
      "padding": "0 15px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeHelper($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.cancel))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "tasks",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": _vm.close,
      "md-esc-to-close": _vm.close
    }
  }, [_c('md-dialog-content', [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v("Prestaciones de la consulta")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    staticClass: "modal-wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-list', {
    staticClass: "task_list"
  }, [(_vm.currentOffice.tasks.length == 0) ? _c('md-list-item', [_vm._v("\n                        Sin Prestaciones en venta\n                    ")]) : _vm._e(), _vm._v(" "), _c('md-list-item', {
    staticClass: "table_header"
  }, [_c('div', {
    staticClass: "pseudo_table w50"
  }, [_c('b', [_vm._v("Prestacion")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_table w25"
  }, [_c('b', [_vm._v("CoPago Fonasa")])]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_table w25"
  }, [_c('b', [_vm._v("Precio Particular")])])]), _vm._v(" "), _vm._l((_vm.currentOffice.tasks), function(row, rowIndex) {
    return _c('md-list-item', {
      key: row.id
    }, [_c('div', {
      staticClass: "pseudo_table w50 is_name"
    }, [_c('md-icon', {
      staticClass: "icon-delete raised delete_presta",
      nativeOn: {
        "click": function($event) {
          _vm.removePrestation(row, rowIndex)
        }
      }
    }, [_vm._v("delete")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row.task.code))]), _vm._v("-" + _vm._s(row.task.name) + "\n                            "), _c('div', {
      staticClass: "data-mobile"
    }, [_c('b', [_vm._v("CoPago Fonasa")]), _vm._v("\n                        $" + _vm._s(row.fonasa_price) + "\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Precio Particular")]), _vm._v("\n                        $" + _vm._s(row.particular_price) + "\n\n\n                            ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "pseudo_table w25 is_data"
    }, [_vm._v("\n                        $" + _vm._s(row.fonasa_price) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "pseudo_table w25 is_data"
    }, [_vm._v("\n                        $" + _vm._s(row.particular_price) + "\n                        ")])])
  })], 2), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    staticStyle: {
      "width": "100%"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openDialog('addTask', _vm.currentOffice)
      }
    }
  }, [_vm._v("Añadir una Prestación")])], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "modal--footer"
  }, [_c('md-button', {
    staticClass: "float-l md-primary sm-size md-size btn--cancel",
    staticStyle: {
      "padding": "0 15px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('tasks')
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.cancel))])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "addTask",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom",
      "md-click-outside-to-close": _vm.close,
      "md-esc-to-close": _vm.close
    }
  }, [_c('md-dialog-content', [_c('h3', {
    staticClass: "dialog--title"
  }, [_vm._v("Añadir Prestacion")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content-main"
  }, [_c('md-layout', {
    staticClass: "modal-wrap",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': false
    }
  }, [_c('label', [_vm._v("Codigo FONASA de Prestación")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.addTaskData.task_code),
      callback: function($$v) {
        _vm.addTaskData.task_code = $$v
      },
      expression: "addTaskData.task_code"
    }
  }), _vm._v(" "), (false) ? _c('span', {
    staticClass: "md-error"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isTasked()) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#f6f6f6",
      "padding": "10px"
    }
  }, [_vm._v("\n                                        Ya tienes esta Prestación, si deseas actualizar los precios elimina la Prestación anterior primero.\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.addTaskData.bonus_task && !_vm.isTasked()) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "background": "#f6f6f6",
      "padding": "10px"
    }
  }, [_c('b', [_vm._v("Prestación: ")]), _vm._v(" " + _vm._s(_vm.addTaskData.bonus_task.name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("CoPago FONASA:")]), _vm._v(" $" + _vm._s(_vm.addTaskData.bonus_task.previsions[0].pivot.final_price) + "\n                                        "), _c('hr'), _vm._v(" "), _c('b', [_vm._v("Defina sus precios (CLP):")]), _c('br'), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': false
    }
  }, [_c('label', [_vm._v("CoPago FONASA")]), _vm._v(" "), _c('md-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.addTaskData.copago_amplifier),
      callback: function($$v) {
        _vm.addTaskData.copago_amplifier = $$v
      },
      expression: "addTaskData.copago_amplifier"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "1",
      "selected": ""
    }
  }, [_vm._v("CoPago sin adicional")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2 veces el CoPago")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 veces el CoPago")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4 veces el CoPago")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 veces el CoPago")])], 1)], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': false
    }
  }, [_c('label', [_vm._v("Precio Particular")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.addTaskData.task_particular_price),
      callback: function($$v) {
        _vm.addTaskData.task_particular_price = $$v
      },
      expression: "addTaskData.task_particular_price"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', {
    staticClass: "modal--footer"
  }, [_c('md-button', {
    staticClass: "float-l md-primary sm-size md-size btn--cancel",
    staticStyle: {
      "padding": "0 15px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('addTask')
      }
    }
  }, [_vm._v(_vm._s(_vm.translate.pages.office.edit.cancel))]), _vm._v(" "), _c('md-button', {
    staticClass: "float-r md-primary sm-size md-size btn--blue add_task_btn",
    staticStyle: {
      "padding": "0 15px"
    },
    attrs: {
      "disabled": !_vm.addTaskData.bonus_task || !_vm.addTaskData.task_particular_price || _vm.isTasked()
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('addTask', true)
      }
    }
  }, [_vm._v("Agregar")])], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5952e086"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/Office/Index.vue
// module id = 693
// module chunks = 1